import { Link } from 'react-router-dom'
import { Mail } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-400 border-t border-slate-900">
      <div className="container-max section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-secondary-500 rounded-xl flex items-center justify-center shadow-lg shadow-primary-500/10">
                <span className="text-white font-extrabold text-sm tracking-wider">FG</span>
              </div>
              <div>
                <h3 className="text-lg font-bold text-white font-display">FG Falke</h3>
                <p className="text-xs font-bold text-secondary-500 tracking-widest uppercase">Transport & Logistyka</p>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Profesjonalne usługi transportowe i logistyczne na trasach Polska ↔ Szwajcaria ↔ Niemcy. 
              Gwarancja rzetelności i bezpieczeństwa ładunku.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-slate-200 mb-5">Szybkie linki</h4>
            <ul className="space-y-3 text-sm">
              {[
                { name: 'Strona główna', href: '/' },
                { name: 'O firmie', href: '/about' },
                { name: 'Usługi', href: '/services' },
                { name: 'Cennik', href: '/pricing' },
                { name: 'Kontakt', href: '/contact' }
              ].map(link => (
                <li key={link.name}>
                  <Link to={link.href} className="hover:text-white transition-colors duration-200 flex items-center">
                    <span className="w-1.5 h-1.5 bg-secondary-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-slate-200 mb-5">Oferta</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>• Transport międzynarodowy</li>
              <li>• Licencje & CKZ</li>
              <li>• Rozliczanie kierowców</li>
              <li>• Transport chłodniczy</li>
              <li>• Doradztwo transportowe</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-slate-200 mb-5">Kontakt</h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start space-x-3">
                <Mail className="w-4 h-4 text-secondary-500 mt-0.5 shrink-0" />
                <a href="mailto:mariusz.sokolowski@fgfalke.eu" className="hover:text-white transition-colors break-all">
                  mariusz.sokolowski@fgfalke.eu
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-secondary-500 font-bold text-xs shrink-0 mt-0.5">📞 CH:</span>
                <a href="tel:+41762373301" className="hover:text-white transition-colors">
                  +41 76 237 33 01
                </a>
              </li>
              <li className="flex items-start space-x-3 text-slate-400">
                <span className="text-secondary-500 font-bold text-xs shrink-0 mt-0.5">📍 PL:</span>
                <span>Szczurowa, małopolskie</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-900 mt-12 pt-8 text-xs">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500">
              © {new Date().getFullYear()} FG Falke. Wszystkie prawa zastrzeżone.
            </p>
            <div className="flex space-x-4">
              <span className="text-slate-500 flex items-center gap-1">🇵🇱 <span className="hover:text-slate-400 cursor-pointer">PL</span></span>
              <span className="text-slate-500 flex items-center gap-1">🇩🇪 <span className="hover:text-slate-400 cursor-pointer">DE</span></span>
              <span className="text-slate-500 flex items-center gap-1">🇬🇧 <span className="hover:text-slate-400 cursor-pointer">EN</span></span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
